export const Device = {
  getId: async () => ({ identifier: '' }),
  getInfo: async () => ({
    platform: 'web',
    manufacturer: '',
    model: '',
    name: '',
    osVersion: '',
    webViewVersion: ''
  })
}
